<div class="password-reset">
    <div>
        <form>
            <div class="row margin-top">
                <div class="col-md-5 label">*{{'bikeshop.modal.add_edit_user.reset_password.new_password' | translate }}
                    :
                </div>
                <div class="col-md-7">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><span class="fa fa-lock"></span></span>
                        <input type="password" pInputText [(ngModel)]="password"
                               placeholder="{{'bikeshop.modal.add_edit_user.reset_password.enter_new_password' | translate }}"
                               autocomplete="new-password" [ngModelOptions]="{standalone: true}"/>
                    </div>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-5 label">
                    *{{'bikeshop.modal.add_edit_user.reset_password.confirm_password' | translate }}:
                </div>
                <div class="col-md-7">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><span class="fa fa-lock"></span></span>
                        <input type="password" pInputText [(ngModel)]="confirmPassword"
                               placeholder="{{'bikeshop.modal.add_edit_user.reset_password.confirm_password' | translate }}"
                               autocomplete="new-password" [ngModelOptions]="{standalone: true}"/>
                    </div>
                </div>
            </div>
        </form>
        <div class="margin-top-16" *ngIf="error">
            {{errorMessage}}
        </div>
    </div>
    <div>
        <div class="row margin-top-16">
            <div class="col-md-6"></div>
            <div class="col-md-6">
                <button pButton type="button"
                        [disabled]="busy || (password.length<6 || password!==confirmPassword)"
                        class="p-button-raised full-width"
                        (click)="changePassword()"
                        label="{{'bikeshop.modal.add_edit_user.reset_password.button.change_password' | translate }}"></button>
            </div>
        </div>
    </div>
</div>
